<script setup lang="ts">
import { NavigationBreadcrumbs } from '@shared/ui/menus'

import { useTutorDetailHeader } from '../model/tutor-detail-header.hook'

defineOptions({
  name: 'TutorDetailHeader',
})

const props = defineProps<{
  text: string
}>()

const {
  config,
} = useTutorDetailHeader({
  text: props.text,
})
</script>

<template>
  <NavigationBreadcrumbs
    :config="config"
  />
</template>
